import { useMount, useStates } from '@tiger/hooks';
import React from 'react';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import API from 'utils/API';
import http from 'utils/http';

interface IGetSingleImgProps {
    url: string;
}

interface IGetSingleImgStates {
    loading: boolean;
    error: null | Error;
    src: string;
}

const GetSingleImg: React.FC<IGetSingleImgProps> = props => {
    const [state, setState] = useStates<IGetSingleImgStates, {}>({
        loading: false,
        error: null,
        src: ''
    });

    const getSingleImg = async () => {
        setState({
            loading: true,
            error: null
        });

        try {
            const res = await http.get(API.CUSTOMER.getFile(props.url), {
                responseType: 'arraybuffer'
            });

            const blob = new Blob([res as any], {
                type: res.type
            });
            const urlObj = window.URL.createObjectURL(blob);

            setState({
                src: urlObj
            });

            setTimeout(() => {
                window.URL.revokeObjectURL(urlObj);
            }, 1000);
        } catch (err) {
            setState({
                error: err
            });
        }

        setState({
            loading: false
        });
    };

    useMount(() => {
        getSingleImg();
    });

    if (state.loading) {
        return <Loading tip={__('加载中...')} />;
    }

    if (state.error) {
        return <ErrorBox error={state.error} onClick={() => getSingleImg()} />;
    }

    return <img src={state.src} alt="preview" />;
};

export default GetSingleImg;
